export default {
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    cascadeFrom: {
        type: String,
        default: undefined
    },
    cascadeFromField: {
        type: String,
        default: undefined
    },
    cascadeFromParentField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataTextField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: String,
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    fixedGroupTemplate: {
        type: [String, Function],
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    groupTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: Number,
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    index: {
        type: Number,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    optionLabel: {
        type: [String, Object],
        default: undefined
    },
    optionLabelTemplate: {
        type: [String, Function],
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    valueTemplate: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Number],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },
    virtual: {
        type: [Boolean, Object],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    }, 
    filtering: Function,
    open: Function,
    select: Function,
    cascade: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoDropDownList/DropDownListProps.js